import { customInstance } from "@repo/api-client";
import type { ManagerPinStatusResponse } from "@repo/api-client";

const path = (venueId: string) =>
  `/api/v1/venues/${encodeURIComponent(venueId)}/staff/me/manager-pin`;

export const managerPinKeys = {
  status: (venueId: string) => ["venue", venueId, "staff", "manager-pin"] as const,
};

export const managerPinApi = {
  get: (venueId: string) =>
    customInstance<ManagerPinStatusResponse>(path(venueId), { method: "GET" }),

  set: (venueId: string, body: { pin: string; currentPin?: string }) =>
    customInstance<ManagerPinStatusResponse>(path(venueId), {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
};
